import { render, staticRenderFns } from "./DeletedChanges.vue?vue&type=template&id=1ef86871&"
import script from "./DeletedChanges.vue?vue&type=script&lang=js&"
export * from "./DeletedChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports